<template>
    <div data-component="AmsListItemBadges" class="flex flex-wrap gap-8">
        <AmsTooltip
            v-for="badge in item.badges"
            :key="badge"
            v-slot="{ isActive }"
            :tooltip="createTooltip(badge)"
            :position="tooltipPosition"
            @click.stop
        >
            <cs-tag is-icon-right>
                {{ badge }}
                <template #icon>
                    <ms-information-circle class="transition-colors" :class="{ 'text-dustygray': !isActive }" />
                </template>
            </cs-tag>
        </AmsTooltip>
    </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import AmsTooltip, { Tooltip } from '../AmsTooltip'
import { CsTag } from '@sunrise/components'
import { MsInformationCircle } from '@sunrise/icons'
import { AmsItem, Badge } from '../../services/amsSearch/amsSearch.interface'
import { Components } from '@sunrise/types'

const props = defineProps({
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
    hasDynamicTooltip: {
        type: Boolean,
        default: false,
    },
})

const tooltipPosition = props.hasDynamicTooltip ? undefined : Components.CsTooltip.TooltipPosition.Top

function createTooltip(badge: Badge): Tooltip {
    const TOOLTIP_LINK = {
        url: 'https://www.kba.de/DE/Statistik/Kraftverkehr/VerkehrKilometer/verkehr_in_kilometern_node.html',
        linkText: 'Kraftfahrt-Bundesamt',
        prefix: '*Quelle: ',
    }
    const badgeTextsMap: Record<Badge, string> = {
        [Badge.NewCar]:
            'Fahrzeuge, mit einer Laufleistung von bis zu 50 km, deren Erstzulassung bis zu einem Jahr zurückliegt',
        [Badge.AnnualCar]:
            'Fahrzeuge, mit einer Laufleistung über 50 km, deren Erstzulassung bis zu einem Jahr zurückliegt.',
        [Badge.LowConsumption]:
            'Fahrzeuge, die gemessen an ihrem Alter im Schnitt unterhalb der allgemein anzunehmenden Laufleistung pro Jahr* liegen.',
        [Badge.Youngtimer]:
            'Fahrzeuge, deren Erstzulassung mehr als 20, höchstens aber 30 Jahre (gerundet auf den Monat), zurückliegt.',
        [Badge.YoungUsed]:
            'Fahrzeuge, deren Erstzulassung mehr als ein, höchstens aber vier Jahre (gerundet auf den Monat), zurückliegt.',
    }

    const tooltipData = {
        title: badge,
        text: badgeTextsMap[badge],
    }

    if (badge === Badge.LowConsumption) {
        Object.assign(tooltipData, TOOLTIP_LINK)
    }

    return tooltipData
}
</script>
